const SET_PREVIOUS_PAGE = (state, payload) => {
  state.previousPage = payload;
};

export default {
  SET_PREVIOUS_PAGE
}